// extracted by mini-css-extract-plugin
export var privacyTrigger = "styles-module__privacyTrigger___Ee9bz";
export var checkbox = "styles-module__checkbox___ybCWA";
export var checkboxLabel = "styles-module__checkboxLabel___x1p75";
export var managedMembers = "styles-module__managedMembers___l3a3P";